import { Api } from "./Api";
import * as apiFactory from "./ApiFactory";

import type { Job } from "@/models/Job";

export async function GetJobs(clientName: string, brand: string, includeClientLevel: boolean): Promise<Job[]> {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<Job[]>(`api/my/jobs/${clientName}/${brand}?includeClientLevel=${includeClientLevel}`);
}

export async function RetryJob(clientName: string, brand: string | null, jobId: string): Promise<void> {
  const client: Api = await apiFactory.WithBearer();
  await client.put<void, void>(`api/my/jobs/${clientName}/${jobId}${brand == null ? "" : `?brand=${brand}`}`);
}

export async function DeleteJob(clientName: string, brand: string | null, jobId: string): Promise<void> {
  const client: Api = await apiFactory.WithBearer();
  await client.delete<void, void>(`api/my/jobs/${clientName}/${jobId}${brand == null ? "" : `?brand=${brand}`}`);
}
